import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const showBranchInfoData = createAsyncThunk(
    "show/info/fetchData",
    async ({ id }) => {
        try {
            const response = await api.get("/info-branches/" + id);
            console.log("res : ", response.data);
            if (response.data?.status === "success") {
                const data = response.data.data;
                return data;
            }
        } catch (error) {
            return error;
        }
    }
);

export const showBranchInfo = createSlice({
    name: "branchInfo",
    initialState: {
        loading: false,
        error: null,
        data: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(showBranchInfoData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(showBranchInfoData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(showBranchInfoData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },

});

export default showBranchInfo.reducer;

